document.addEventListener('DOMContentLoaded', function () {
    const fromFamily = sessionStorage.getItem('fromFamilySale');
  
    if (fromFamily === 'true') {
      document.body.classList.add('family-sale-mode');
  
      if (document.body.classList.contains('template-cart')) {
        const links = document.querySelectorAll(
          'a.header__heading-link, .title-wrapper-with-link a, .cart__warnings a.button'
        );
  
        links.forEach(link => {
          link.setAttribute('href', '/collections/family-sales');
        });
      }
    }
  });
  